/**
 * Fixed top dock (viewport-wide) after sentinel scrolls above the viewport.
 * Dock is appended to document.body so position:fixed aligns to the window.
 * Vertical position: `top` = bottom edge of the theme `<header>` (live `getBoundingClientRect()`).
 */
(function () {
  function mainAdd(sectionId, root) {
    return root.querySelector(
      '#product-form-' + sectionId + ' button[name="add"]',
    );
  }

  function stickyBtnEl(sectionId, dock) {
    if (!dock) return null;
    return dock.querySelector('#ProductStickyAtcSubmit-' + sectionId);
  }

  function quantityStickyEl(sectionId, dock) {
    if (!dock) return null;
    return dock.querySelector('#Quantity-' + sectionId + '-sticky');
  }

  function elByDomId(root, id) {
    if (!id) return null;
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return root.querySelector('[id="' + CSS.escape(id) + '"]');
    }
    return root.querySelector(
      '[id="' + String(id).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]',
    );
  }

  function syncStickyVariantsFromMain(sectionId, root) {
    var dock = document.getElementById('ProductStickyDock-' + sectionId);
    if (!dock) return;
    dock
      .querySelectorAll('input[data-sticky-atc-target]')
      .forEach(function (stickyRad) {
        var tid = stickyRad.getAttribute('data-sticky-atc-target');
        var mainRad = elByDomId(root, tid);
        if (!mainRad) return;
        if (stickyRad.checked !== mainRad.checked)
          stickyRad.checked = mainRad.checked;
      });
  }

  function attachDockToBody(dock) {
    if (dock && dock.parentElement !== document.body) {
      document.body.appendChild(dock);
    }
  }

  var STICKY_ATC_FALLBACK_TOP_PX = 120;

  function productSiteHeaderEl() {
    return (
      document.querySelector('[data-header]') ||
      document.querySelector('#shopify-section-header header') ||
      document.querySelector('header')
    );
  }

  function headerDockTopPx() {
    var headerEl = productSiteHeaderEl();
    if (!headerEl) return STICKY_ATC_FALLBACK_TOP_PX;
    var r = headerEl.getBoundingClientRect();
    if (r.height < 2) return STICKY_ATC_FALLBACK_TOP_PX;
    return Math.max(0, Math.ceil(r.bottom));
  }

  function syncDockTop(dock) {
    if (!dock) return;
    dock.style.top = headerDockTopPx() + 'px';
  }

  /** Hysteresis — never use main padding (layout shift). Sentinel is ~1px tall. */
  /** From hidden: show once sentinel has passed the top of the viewport (past buy area). */
  var STICKY_ATC_ENGAGE_BOTTOM_PX = 6;
  /** While visible: hide after user scrolls back up until sentinel dips this far into the viewport */
  var STICKY_ATC_RELEASE_BOTTOM_PX = 56;

  function readSentinelAsEntry(sentinel) {
    var r = sentinel.getBoundingClientRect();
    var h =
      typeof window !== 'undefined' &&
      window.visualViewport &&
      window.visualViewport.height
        ? window.visualViewport.height
        : window.innerHeight || 0;
    var w =
      typeof window !== 'undefined' &&
      window.visualViewport &&
      window.visualViewport.width
        ? window.visualViewport.width
        : window.innerWidth || 0;
    var overlaps = !(
      r.bottom <= 0 ||
      r.top >= h ||
      r.right <= 0 ||
      r.left >= w
    );
    return { isIntersecting: overlaps, boundingClientRect: r };
  }

  function nextDockVisibility(entry, visibleNow) {
    if (!entry) return !!visibleNow;
    /** Marker is on screen — primary buy block is in/near view */
    if (entry.isIntersecting) return false;

    var r = entry.boundingClientRect || {};
    var b = typeof r.bottom === 'number' ? r.bottom : 0;
    var t = typeof r.top === 'number' ? r.top : 0;

    if (!visibleNow) {
      /**
       * Require the sentinel to actually be above/past the viewport top.
       * Previously `bottom <= -12` left a dead zone where IO could be !intersecting
       * but the bar would never re-engage after a small scroll-up.
       */
      var pastTop = t < 0 || b <= STICKY_ATC_ENGAGE_BOTTOM_PX;
      return pastTop;
    }
    return b < STICKY_ATC_RELEASE_BOTTOM_PX;
  }

  function wireVariantSync(sectionId, root) {
    var dock = document.getElementById('ProductStickyDock-' + sectionId);
    if (!dock) return;

    dock.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio')
        return;
      if (!input.hasAttribute('data-sticky-atc-target')) return;
      var tid = input.getAttribute('data-sticky-atc-target');
      var mainRad = elByDomId(root, tid);
      if (mainRad) {
        mainRad.checked = true;
        mainRad.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncStickyVariantsFromMain(sectionId, root);
    });

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio')
        return;
      var vr = input.closest(
        'variant-radios[data-section="' + sectionId + '"]',
      );
      if (!vr || !root.contains(vr)) return;
      syncStickyVariantsFromMain(sectionId, root);
    });
  }

  function wireQuantity(sectionId, root, dock) {
    var main = root.querySelector('#Quantity-' + sectionId);
    var sticky = quantityStickyEl(sectionId, dock);
    if (!main || !sticky) return;

    function pull(from, to) {
      if (to.value === from.value) return;
      to.value = from.value;
    }

    ['input', 'change'].forEach(function (evtName) {
      main.addEventListener(evtName, function () {
        pull(main, sticky);
      });
    });

    sticky.addEventListener('input', function () {
      if (main.value !== sticky.value) {
        main.value = sticky.value;
        main.dispatchEvent(new Event('input', { bubbles: true }));
        main.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function mirrorStickyAdd(sectionId, root, dock) {
    var mainBtn = mainAdd(sectionId, root);
    var stickyBtn = stickyBtnEl(sectionId, dock);
    if (!mainBtn || !stickyBtn) return;

    function syncVisual() {
      var mainSpan = mainBtn.querySelector(':scope > span');
      var stickySpan = stickyBtn.querySelector(':scope > span');
      if (mainSpan && stickySpan) stickySpan.textContent = mainSpan.textContent;
      var mainDisabled =
        mainBtn.hasAttribute('disabled') ||
        mainBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.toggleAttribute('disabled', mainDisabled);
      stickyBtn.classList.toggle(
        'loading',
        mainBtn.classList.contains('loading'),
      );
      var ms = mainBtn.querySelector('.loading-overlay__spinner');
      var ss = stickyBtn.querySelector('.loading-overlay__spinner');
      if (ms && ss)
        ss.classList.toggle('hidden', ms.classList.contains('hidden'));
    }

    syncVisual();
    var mo = new MutationObserver(syncVisual);
    mo.observe(mainBtn, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });
  }

  function setDockVisible(dock, vis) {
    if (!dock) return;
    if (vis) {
      dock.removeAttribute('hidden');
      dock.removeAttribute('inert');
      dock.classList.add('is-visible');
      dock.setAttribute('aria-hidden', 'false');
    } else {
      dock.setAttribute('hidden', '');
      dock.setAttribute('inert', '');
      dock.classList.remove('is-visible');
      dock.setAttribute('aria-hidden', 'true');
    }
  }

  function init(sectionRoot, sectionId) {
    var dock =
      sectionRoot.querySelector('#ProductStickyDock-' + sectionId) ||
      document.getElementById('ProductStickyDock-' + sectionId);
    var sentinel = sectionRoot.querySelector(
      '#ProductStickySentinel-' + sectionId,
    );
    if (!dock || !sentinel) return;

    attachDockToBody(dock);
    syncDockTop(dock);

    var stickyBtn = stickyBtnEl(sectionId, dock);

    wireVariantSync(sectionId, sectionRoot);
    wireQuantity(sectionId, sectionRoot, dock);
    mirrorStickyAdd(sectionId, sectionRoot, dock);
    syncStickyVariantsFromMain(sectionId, sectionRoot);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var mb = mainAdd(sectionId, sectionRoot);
        if (mb) mb.click();
      });
    }

    var dockVisible = false;

    var dockTopQueued = false;
    function scheduleDockTopSync() {
      if (dockTopQueued) return;
      dockTopQueued = true;
      requestAnimationFrame(function () {
        dockTopQueued = false;
        syncDockTop(dock);
      });
    }

    window.addEventListener('scroll', scheduleDockTopSync, { passive: true });
    window.addEventListener('resize', scheduleDockTopSync);

    function applyDockVisibility(nextVisible) {
      if (!!nextVisible === dockVisible) {
        scheduleDockTopSync();
        return;
      }
      dockVisible = nextVisible;
      setDockVisible(dock, dockVisible);
      scheduleDockTopSync();
      syncStickyVariantsFromMain(sectionId, sectionRoot);
    }

    function onIntersection(entries) {
      applyDockVisibility(nextDockVisibility(entries[0], dockVisible));
    }

    var io = new IntersectionObserver(onIntersection, {
      root: null,
      threshold: 0,
      rootMargin: '0px',
    });

    io.observe(sentinel);

    applyDockVisibility(
      nextDockVisibility(readSentinelAsEntry(sentinel), dockVisible),
    );

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(scheduleDockTopSync).observe(dock);
      var hdrEl = productSiteHeaderEl();
      if (hdrEl) {
        new ResizeObserver(scheduleDockTopSync).observe(hdrEl);
      }
    }
  }

  function boot() {
    document
      .querySelectorAll('section[data-sticky-product-atc]')
      .forEach(function (sectionEl) {
        var sectionId = sectionEl.getAttribute('data-sticky-product-atc');
        if (!sectionId) return;
        init(sectionEl, sectionId);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
